// removed by extract-text-webpack-plugin
module.exports = {"flier-container":"locked-event__flier-container__1v-9x","flier":"locked-event__flier__Av15I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/locked-event.scss
// module id = 1473
// module chunks = 1